import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import UserService from "../../../../rest/userService";

const UpdatePasswordForm = ({ userLogin, clientCode, closeModal }) => {
    const [showPassword, setShowPassword] = useState(false);

    const formik = useFormik({
        initialValues: {
            password: "",
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .required("Senha é obrigatória")
                .min(8, "Senha deve ter pelo menos 8 caracteres")
                .matches(/[A-Z]/, "Senha deve ter pelo menos uma letra maiúscula")
                .matches(/[a-z]/, "Senha deve ter pelo menos uma letra minúscula")
                .matches(/[0-9]/, "Senha deve ter pelo menos um número")
                .matches(/[!@#$%^&*(),.?":{}|<>]/, "Senha deve ter pelo menos um símbolo"),
        }),
        onSubmit: async (values) => {
            try {
                // Criar DTO simples para envio
                const updatePasswordDTO = {
                    login: userLogin,
                    password: values.password,
                    clientCode: clientCode,
                };

                await UserService.updateUserPassword(updatePasswordDTO);
                toast.success("Senha atualizada com sucesso!");
                closeModal();
            } catch (err) {
                console.error(err);
                toast.error("Erro ao atualizar senha");
            }
        },
    });

    return (
        <form
            id="updatePasswordForm"
            onSubmit={formik.handleSubmit}
            className="flex flex-col gap-4"
        >
            <div className="relative">
                <label className="text-custom_gray_font">Nova Senha</label>
                <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="w-full px-4 py-2 border rounded-xl mt-1"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                />
                <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-2 top-9 text-gray-500"
                >
                    {showPassword ? "Ocultar" : "Mostrar"}
                </button>
                {formik.touched.password && formik.errors.password && (
                    <p className="text-red-500 text-sm mt-1">{formik.errors.password}</p>
                )}
            </div>
        </form>
    );
};

export default UpdatePasswordForm;
